// Indicizza le coordinate per objectId dell'org: { [orgId]: { lat, lng } }.
export const buildCoordsIndex = (coords) => {
  const idx = {};
  (coords || []).forEach((c) => {
    const orgId = c.org_pointer && c.org_pointer.objectId;
    if (orgId && c.latitude != null && c.longitude != null) {
      idx[orgId] = { lat: c.latitude, lng: c.longitude };
    }
  });
  return idx;
};

// Arricchisce ogni documento con orgLat/orgLng (null se l'org non ha coordinate).
export const joinDocsWithCoords = (docs, idx) =>
  (docs || []).map((d) => {
    const orgId = d.org_pointer && d.org_pointer.objectId;
    const c = orgId ? idx[orgId] : null;
    return { ...d, orgLat: c ? c.lat : null, orgLng: c ? c.lng : null };
  });

// Valori unici ordinati estratti con un accessor, scartando i falsy.
export const getUniqueValues = (docs, accessor) => {
  const set = new Set();
  (docs || []).forEach((d) => {
    let v;
    try {
      v = accessor(d);
    } catch (e) {
      v = null;
    }
    if (v) set.add(v);
  });
  return Array.from(set).sort();
};

// Applica tutti i filtri in AND. `calculateDistance` è iniettata (riuso da MappaClienti/utils).
export const filterDocs = (docs, filters, calculateDistance) => {
  const { nome, org, formato, contentIds, map } = filters;
  return (docs || []).filter((d) => {
    const isPdf = !!(d.pdf_form && d.pdf_form.url);
    if (nome && !(d.nome_documento || "").toLowerCase().includes(nome.toLowerCase())) return false;
    if (org && (!d.org_pointer || d.org_pointer.objectId !== org)) return false;
    if (formato === "pdf" && !isPdf) return false;
    if (formato === "html" && isPdf) return false;
    if (contentIds && !contentIds.has(d.objectId)) return false;
    if (map) {
      if (d.orgLat == null || d.orgLng == null) return false;
      const dist = calculateDistance(map.center.lat, map.center.lng, d.orgLat, d.orgLng);
      if (dist > map.rangeKm) return false;
    }
    return true;
  });
};

// Ordina i documenti secondo il criterio scelto (non muta l'array originale).
export const sortDocs = (docs, sortBy) => {
  const arr = [...(docs || [])];
  switch (sortBy) {
    case "updated_asc":
      return arr.sort((a, b) => new Date(a.updatedAt) - new Date(b.updatedAt));
    case "nome_asc":
      return arr.sort((a, b) =>
        (a.nome_documento || "").localeCompare(b.nome_documento || "")
      );
    case "nome_desc":
      return arr.sort((a, b) =>
        (b.nome_documento || "").localeCompare(a.nome_documento || "")
      );
    case "updated_desc":
    default:
      return arr.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  }
};

export const pruneSelectionToDocs = (selectedIds, docs) => {
  if (!selectedIds || selectedIds.size === 0) return selectedIds || new Set();

  const visibleIds = new Set((docs || []).map((d) => d.objectId));
  let changed = false;
  const next = new Set();

  selectedIds.forEach((id) => {
    if (visibleIds.has(id)) {
      next.add(id);
    } else {
      changed = true;
    }
  });

  return changed ? next : selectedIds;
};

export const getSelectedDocs = (docs, selectedIds) =>
  (docs || [])
    .filter((d) => selectedIds.has(d.objectId))
    .map((d) => ({ objectId: d.objectId, nome_documento: d.nome_documento }));
